import { parseMessageFromFirebase } from '@/helpers/chat'

const state = {
  chats: [],
  messagesSubscriber: new Map()
};

const getters = {
  getChats: (state) => state.chats,
  getChatsByPhone: (state) => (phone) => { return state.chats.find(chat => chat.data.phone === phone && chat.data.status !== 2)},
  getChatByRoomId: (state) => (roomId) => (state.chats.find(chat => chat.roomId === roomId)),
};

const mutations = {
  PUSH_TO_CHATS: (state, chat) => (state.chats.push(chat)),
  ADD_MESSAGE_TO_CHAT(state, { roomId, message }) {
    const chat = state.chats.find(chat => chat.roomId === roomId)

    if (!chat.messages.find(m => m.id === message.id)) {
      chat.messages.push(message);
    }

    state.chats = [...state.chats.filter(c => c.roomId !== chat.roomId), chat]
  },
  ADD_UNPARSED_MESSAGE_TO_CHAT(state, { roomId, unparsedMessage }) {
    const chat = state.chats.find(chat => chat.roomId === roomId);
    chat.unparsedMessages.unshift(unparsedMessage);
    state.chats = [...state.chats.filter(c => c.roomId !== chat.roomId), chat]
  },
  ADD_PREVIUS_MESSAGE_TO_CHAT(state, { roomId, message }) {
    const chat = state.chats.find(chat => chat.roomId === roomId)

    if (!chat.messages.find(m => m.id === message.id)) {
      chat.messages.unshift(message);
    }

    state.chats = [...state.chats.filter(c => c.roomId !== chat.roomId), chat]
  },
  RESET_UNREAD_MESAGE_TO_CHAT(state, roomId) {
    const chat = state.chats.find(chat => chat.roomId === roomId)
    chat.unreadMessages = 0;
    state.chats = [...state.chats.filter(c => c.roomId !== chat.roomId), chat]
  },
  SUM_UNREAD_MESSAGE_TO_CHAT(state, roomId) {
    const chat = state.chats.find(chat => chat.roomId === roomId)
    chat.unreadMessages++;
    state.chats = [...state.chats.filter(c => c.roomId !== chat.roomId), chat]
  },
  UPDATE_DATA(state, { roomId, data }) {
    const chat = state.chats.find(chat => chat.roomId === roomId);
    chat.data = data;
    state.chats = [...state.chats.filter(c => c.roomId !== chat.roomId), chat]
  },
  UPDATE_UNSUBSCRIBE(state, { roomId, unsubscribe }) {
    const chat = state.chats.find(chat => chat.roomId === roomId);
    chat.unsubscribe = unsubscribe;
    state.chats = [...state.chats.filter(c => c.roomId !== chat.roomId), chat]
  },
  RESET_MESSAGES_FROM_CHAT(state, roomId) {
    const chat = state.chats.find(chat => chat.roomId === roomId);
    chat.messages = [];
    state.chats = [...state.chats.filter(c => c.roomId !== chat.roomId), chat]
  },
  SET_LAST_MESSAGE(state, { roomId, message }) {
    const chat = state.chats.find(chat => chat.roomId === roomId)
    chat.lastMessage = message
    state.chats = [...state.chats.filter(c => c.roomId !== roomId), chat]
  },
  UPDATE_MESSAGE(state, { roomId, message } ) {
    const chat = state.chats.find(chat => chat.roomId === roomId)
    chat.messages = chat.messages.map((msg) => msg.id === message.id ? message : msg)
    state.chats = [...state.chats.filter(c => c.roomId !== roomId), chat]
  },
  SET_ANSWER_MESSAGE(state, { roomId, message }) {
    const chat = state.chats.find(chat => chat.roomId === roomId)
    chat.answerMessage = message
    state.chats = [...state.chats.filter(c => c.roomId !== roomId), chat]
  },
  UPDATE_UNREAD_MESSAGE: (state, {roomId, value}) => {
    const chat = state.chats.find(chat => chat.roomId === roomId)
    if (chat) {
      chat.unreadMessages = value;
      state.chats = [...state.chats.filter(c => c.roomId !== roomId), chat]
    }
  },
  UPDATE_INTERNAL_NOTES: (state, {roomId, internalNote}) => {
    const chat = state.chats.find(chat => chat.roomId === roomId)
    chat.internalNotes = chat.internalNotes ?? []
    let localInternalNote = chat.internalNotes.find( item => item.id === internalNote.id)
    if(localInternalNote){
      localInternalNote = internalNote
      chat.internalNotes = [...chat.internalNotes.filter(c => c.id !== internalNote.id), localInternalNote] 
    }else{
      chat.internalNotes.push(internalNote)
    }
    state.chats = [...state.chats.filter(c => c.roomId !== roomId), chat]
  },
  REMOVE_INTERNAL_NOTE: (state, {roomId, noteId}) => {
    const chat = state.chats.find(chat => chat.roomId === roomId)
    chat.internalNotes = chat.internalNotes ?? []
    let localInternalNote = chat.internalNotes.find( item => item.id === noteId)
    if(localInternalNote){
      chat.internalNotes = [...chat.internalNotes.filter(c => c.id !== noteId)] 
    }
    state.chats = [...state.chats.filter(c => c.roomId !== roomId), chat]
  },
  UPDATE_INTERNAL_UNSUBSCRIBE(state, { roomId, internalNotesUnsubscribe }) {
    const chat = state.chats.find(chat => chat.roomId === roomId);
    chat.internalNotesUnsubscribe = internalNotesUnsubscribe;
    state.chats = [...state.chats.filter(c => c.roomId !== chat.roomId), chat]
  },
  UPDATE_LOADING_MESSAGES(state, { roomId, value }) {
    const chat = state.chats.find(chat => chat.roomId === roomId);
    chat.loadingMessages = value;
    state.chats = [...state.chats.filter(c => c.roomId !== chat.roomId), chat]
  },
  REMOVE_CHAT(state, roomId) {
    state.chats = state.chats.filter(chat => chat.roomId !== roomId)
  },
  ADD_MESSAGE_SUBSCRIBER (state, { roomId, messageId, unsubscribe }) {
    if (state.messagesSubscriber.has(roomId)) { 
      const messages = state.messagesSubscriber.get(roomId)
      messages[messageId] = unsubscribe
      state.messagesSubscriber.set(roomId, messages)
    } else {
      state.messagesSubscriber.set(roomId, { [messageId] : unsubscribe })
    }
  },
  REMOVE_MESSAGE_SUBSCRIBER(state, {roomId, messageId}) {
    if (state.messagesSubscriber.has(roomId)) { 
      const messages = state.messagesSubscriber.get(roomId)
      delete messages[messageId] 
      state.messagesSubscriber.set(roomId, messages)
    }
  },
  ADD_ANSWER_MESSAGE_FROM_CHAT(state, { roomId, message }) {
    state.chats = state.chats.map(chat => chat.roomId === roomId ? { ... chat, context: message} : chat)
  }
};

const actions = {
  initChatroom({ commit }, { name, path, roomId, myself, version = 0 }) {
    commit('PUSH_TO_CHATS', { name: name, roomId: roomId, messages: [], path, myself, unreadMessages: 0, data: {}, unparsedMessages: [], unsubscribe: null, lastMessage: null, answerMessage : null, lastMessageWriten : null, version, loadingMessages: true })
  },
  listenDataFromChatroom({ rootGetters, commit }, { roomId, callback = null }) {
    const firebase = rootGetters.getFirebase;
    const chat = state.chats.find(chat => chat.roomId === roomId);
    if (chat) {
      firebase.firestore().collection(chat.path).doc(roomId).onSnapshot((doc) => {
        if (doc.change !== "removed") {
          commit('UPDATE_DATA', { roomId: roomId, data: doc.data() });
          if (callback) {
            callback(doc.data());
          }
        }
      });
    }
  },
  listenInternalNotesFromChatroom({rootGetters, commit}, {roomId}){
    const firebase = rootGetters.getFirebase;
    const chat = state.chats.find(chat => chat.roomId === roomId);
    if (chat) {
      const internalNotesUnsubscribe = firebase.firestore().collection(chat.path).doc(roomId).collection('internalNotes').onSnapshot((snapshot) => {
        snapshot.docs.forEach((doc) => {
          if (doc.change !== "removed") {
            commit('UPDATE_INTERNAL_NOTES', { roomId: roomId, internalNote: {...doc.data(), id: doc.id }});
          }
        })
      });
      commit('UPDATE_INTERNAL_UNSUBSCRIBE', {roomId, internalNotesUnsubscribe})
    }
  },
  async fetchLastMessageFromChatroom({ rootGetters, commit }, { roomId, callback = null }) {
    const firebase = rootGetters.getFirebase;
    const chat = state.chats.find(chat => chat.roomId === roomId);
    if (chat) {
      try {
        const orderByField = chat.version === 3 ? 'createdAt' : 'date'
        const querySnap = await firebase.firestore().collection(chat.path).doc(roomId).collection('messages').orderBy(orderByField, 'desc').limit(1).get();
         
        const lastMessage = querySnap.docs[0] ? querySnap.docs[0] : null;
        const message = lastMessage ? parseMessageFromFirebase({...lastMessage.data(), id : lastMessage.id}) : null;
        commit("SET_LAST_MESSAGE", { roomId, message });

        if (callback) {
          callback(message)
        }

      } catch (error) {
        console.log(error)
      }
    }
  },
  fetchLastMessagesFromChatroomFromTimestamp({ rootGetters, commit }, { roomId, timestamp = new Date().getTime(), callback = null, resetState = false }) {
    const firebase = rootGetters.getFirebase;
    const chat = state.chats.find(chat => chat.roomId === roomId);
    if (chat) {

      commit('UPDATE_LOADING_MESSAGES', { roomId, value: true })

      if (resetState) {
        commit('RESET_MESSAGES_FROM_CHAT', roomId);
      }

      const orderByField = chat.version === 3 ? 'createdAt' : 'date'

      firebase.firestore().collection(chat.path).doc(roomId).collection('messages').where(orderByField, '<=', timestamp).orderBy(orderByField, "desc").limit(15).get()
        .then((collection) => {

          commit('UPDATE_LOADING_MESSAGES', { roomId, value: false })

          if (callback) {
            const documents = collection.docs.map((doc) => {
              return parseMessageFromFirebase({...doc.data(), id : doc.id })
            })
            callback(documents);
          }

          collection.docs.forEach(async (doc) => {
            const tmpMessage = doc.data();
            if (tmpMessage.text !== '') {
              const answersSnap = await doc.ref.collection('answer').get()
              const answer = (answersSnap.size > 0 ) ? parseMessageFromFirebase(await answersSnap.docs.map((answer) => answer.data()).pop()) : null
              const message = {...parseMessageFromFirebase({...doc.data(), id : doc.id }), answer}
              commit('ADD_PREVIUS_MESSAGE_TO_CHAT', { message, roomId });
              commit('ADD_UNPARSED_MESSAGE_TO_CHAT', { roomId: roomId, unparsedMessage: {...doc.data(), id : doc.id} })


              // const lastMessage = chat.messages[0];
              // commit('SET_LAST_MESSAGE', { message: getLastMessage(chat.messages[chat.messages.length - 1]), roomId })
              // if (lastMessage) {
              //   if (hasToAddToPreviusMessage(lastMessage, message)) {
              //     lastMessage.text = message.text + "<br>" + lastMessage.text
              //   } else {
              //     commit('ADD_PREVIUS_MESSAGE_TO_CHAT', { message, roomId });
              //   }
              // } else {
              //   commit('ADD_PREVIUS_MESSAGE_TO_CHAT', { message, roomId });
              // }
            }
          });
        })
    }
  },
  fetchAllMessagesFromChatroom({ rootGetters, commit }, { roomId }) {
    const user = rootGetters.getUser;
    const firebase = rootGetters.getFirebase;
    const chat = state.chats.find(chat => chat.roomId === roomId);
    if (chat) {
      commit('UPDATE_LOADING_MESSAGES', { roomId, value: true })
      const orderByField = chat.version === 3 ? 'createdAt' : 'date'
      firebase.firestore().collection(chat.path).doc(roomId).collection('messages').orderBy(orderByField, "desc").get()
        .then((collection) => {
          commit('UPDATE_LOADING_MESSAGES', { roomId, value: false })
          commit('RESET_MESSAGES_FROM_CHAT', roomId);
          collection.docs.forEach((doc) => {
            const tmpMessage = doc.data();
            if (tmpMessage.text !== '') {

              if (('isReaded' in tmpMessage) && !tmpMessage.isReaded && tmpMessage.from !== user.uid) {
                commit('SUM_UNREAD_MESSAGE_TO_CHAT', roomId);
              }

              const message = parseMessageFromFirebase({...doc.data(), id : doc.id })

              // This only apply to chats from the agent console, for chat engine v1
              if (message.user.id === 0) {
                message.user.name = chat.name
              }

              const tmplastMessage = (chat.messages[chat.messages.length - 1]) ? chat.messages[chat.messages.length - 1] : message
              commit('SET_LAST_MESSAGE', { message: getLastMessage(tmplastMessage), roomId })
              commit('ADD_PREVIUS_MESSAGE_TO_CHAT', { message, roomId })
              commit('ADD_UNPARSED_MESSAGE_TO_CHAT', { roomId: roomId, unparsedMessage: {...doc.data(), id : doc.id} })
            }
          });
        });
      return true;
    }
  },
  stopListenMessagesFromChatroom({ state, commit }, { roomId }) {
    const chat = state.chats.find(chat => chat.roomId === roomId);
    if (chat) {
      if (chat.unsubscribe) {
        chat.unsubscribe();
        commit('UPDATE_UNSUBSCRIBE', { unsubscribe: null, roomId: chat.roomId });
      }
    }
  },
  async listenMessagesFromChatroom({ rootGetters, commit, dispatch }, { roomId, unreadMessagesCallback, newMessageCallback }) {
    const firebase = rootGetters.getFirebase;
    await dispatch("fetchLastMessageFromChatroom", { roomId });
    const chat = state.chats.find(chat => chat.roomId === roomId);
    if (chat && chat.unsubscribe === null) {

    firebase.firestore().collection(chat.path).doc(roomId).collection('messages').where('from', '==', 'system').onSnapshot((snapshot) => {
        for (const change of snapshot.docChanges()) {
          if (change.type === "modified") {
            const message = parseMessageFromFirebase({...change.doc.data(), id : change.doc.id });
            commit('UPDATE_MESSAGE', { message, roomId })
          }
        }        
      })

      const timestamp = !chat.lastMessage ? new Date().getTime() : chat.lastMessage.date
      const orderByField = chat.version === 3 ? 'createdAt' : 'date'
      let orderByValue = chat.version === 3 ? firebase.firestore.Timestamp.now() : timestamp

      const unsubscribe = firebase.firestore().collection(chat.path).doc(roomId).collection('messages').where(orderByField, '>=', orderByValue).onSnapshot((snapshot) => {
        for (const change of snapshot.docChanges()) {

          if (change.type === "added") {
            const message = parseMessageFromFirebase({...change.doc.data(), id : change.doc.id });
            //const lastMessage = chat.messages[chat.messages.length - 1];

            commit('SET_LAST_MESSAGE', { message, roomId })
            console.log(message)
            commit('ADD_MESSAGE_TO_CHAT', { message, roomId });

            // This only apply to chats from the agent console, for chat engine v1
            if (message.user.id === 0) {
              message.user.name = chat.nick
            }

            if (newMessageCallback) {
              newMessageCallback(message);
            }

            if (chat.myself.id !== message.user.id) {
              if (unreadMessagesCallback) {
                unreadMessagesCallback(chat.unreadMessages)
              }
              commit('SUM_UNREAD_MESSAGE_TO_CHAT', roomId)
            }

            commit('ADD_UNPARSED_MESSAGE_TO_CHAT', { roomId: roomId, unparsedMessage: {...change.doc.data(), id : change.doc.id} })
          }
        }
      });
      commit('UPDATE_UNSUBSCRIBE', { unsubscribe: unsubscribe, roomId: chat.roomId });
      return unsubscribe;
    }
  },
  saveMessageFromChatroom({ rootGetters, commit }, { roomId, message }) {
    return new Promise((resolve) => {
      const firebase = rootGetters.getFirebase;
      const chat = state.chats.find(chat => chat.roomId === roomId);
      if (chat) {
        message.createdAt = firebase.firestore.FieldValue.serverTimestamp()

        if (chat.context) {
          message.context = chat.context.customMessageId ?? chat.context.id
          commit('ADD_ANSWER_MESSAGE_FROM_CHAT', { roomId, message: null })
        }

        firebase.firestore().collection(chat.path).doc(roomId).collection('messages').add(message).then((doc) => {
          if (chat.answerMessage) {
            const answer = chat.unparsedMessages.find(msg => msg.id === chat.answerMessage.id)
            firebase.firestore().collection(chat.path).doc(roomId).collection('messages').doc(doc.id).collection('answer').add(answer)
            commit("SET_ANSWER_MESSAGE", { roomId, message : null }) 
          }
          resolve(doc.id)
        })
      }
    })
  },
  uploadFileToStorage({ rootGetters }, { file, callback }) {
    return new Promise((resolve) => {
      const storage = rootGetters.getFirebase.storage();
      const name = `${new Date().getTime()}_${file.name}`;
      const uploadTask = storage.ref(`files/${name}`).put(file);
      const uploading = function (snapshot) {
        callback((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
      }
      uploadTask.on(`state_changed`, uploading, null, () => {
        uploadTask.snapshot.ref.getDownloadURL().then((url) => {
          resolve(url);
        });
      });
    })
  },
  updateUnreadMessages({ commit }, roomId) {
    const chat = state.chats.find(chat => chat.roomId === roomId);
    if (chat) {
      commit('RESET_UNREAD_MESAGE_TO_CHAT', roomId)
    }
  },
  createNewChatroom({ rootGetters }, id) {
    return new Promise(function (resolve) {
      const user = rootGetters.getUser
      const firebase = rootGetters.getFirebase
      const room = new Date().getTime();
      const participants = [user.uid, id];
      firebase.firestore().collection("chats").doc(room + "-").set({ createdAt: new Date().getTime(), participants: [user.uid, id] }).then(() => {
        participants.forEach(uid => firebase.firestore().collection("chats").doc(room + "-").collection("participants").doc(uid).set({ uid }));
        resolve({ id: id, room: room, });
      })
    })
  },
  userIsWriting({ rootGetters }, {roomId, status = true}) {
    const user = rootGetters.getUser
		const firebase = rootGetters.getFirebase
    const chat = state.chats.find(chat => chat.roomId === roomId);
    if (chat) {
      firebase.firestore().collection(chat.path).doc(roomId).update({
        userIsWriting : { [user.uid] : (status) ? user.fullname : null }
      })
    }
  },
  sendSystemMessageToChatroom({rootGetters}, { roomId, data }) {
    return new Promise((resolve, reject) => {
      const firebase = rootGetters.getFirebase;
      const base = {
        from: 'system',
        date: new Date().getTime(),
      }
      firebase.firestore().collection("chats").doc(roomId).collection("messages").add({...base, ...data}).then((doc) => {
        return resolve(doc.id)
      }).catch((error) => {
        return reject(error)
      })
    })
	},
  setAnswerMessage({ commit }, { roomId, message }) {
    commit("SET_ANSWER_MESSAGE", { roomId, message })
  },
  listenToMessage({ rootGetters, commit } , { roomId, messageId}) {
    const firebase = rootGetters.getFirebase;
    const chat = state.chats.find(chat => chat.roomId === roomId);
    if (chat) {
      const unsubscribe = firebase.firestore().collection(chat.path).doc(roomId).collection('messages').doc(messageId).onSnapshot((doc) => {
        const message = parseMessageFromFirebase({...doc.data(), id : doc.id });
        commit('UPDATE_MESSAGE', { message, roomId })
      })
      commit('ADD_MESSAGE_SUBSCRIBER', { roomId, messageId, unsubscribe})
    }
  },
  stopListenInternalNotes({ state, commit }, { roomId }) {
    const chat = state.chats.find(chat => chat.roomId === roomId);
    if (chat) {
      if (chat.internalNotesUnsubscribe) {
        chat.internalNotesUnsubscribe();
        commit('UPDATE_INTERNAL_UNSUBSCRIBE', { internalNotesUnsubscribe: null, roomId: chat.roomId });
      }
    }
  },
  stopListenMessagesStatus({ state, commit }, roomId) {
    if (state.messagesSubscriber.has(roomId)) { 
      const unsubscribes = state.messagesSubscriber.get(roomId)
      Object.keys(unsubscribes).forEach((messageId) => {
        unsubscribes[messageId]()
        commit('REMOVE_MESSAGE_SUBSCRIBER', { roomId, messageId })
      })
    }
  },
  fetchMessagesFromTimestamp({ rootGetters, commit }, { roomId, date }) {
    const firebase = rootGetters.getFirebase;
    const chat = state.chats.find(chat => chat.roomId === roomId);
    if (!chat) {
      return
    }

    const user = rootGetters.getUser;

    const orderByField = chat.version === 3 ? 'createdAt' : 'date'

    let timestamp = date

    // Check the type of timestamp because maybe a timestamp or a FieldValue from Firestore

    if (typeof timestamp === 'number') {
      timestamp = new Date(timestamp)
    } 
      
    if (typeof timestamp === 'object' && '_seconds' in timestamp) {
      timestamp = new Date((timestamp._seconds + 1) * 1000) 
    }

    firebase.firestore().collection(chat.path).doc(roomId).collection('messages').where(orderByField, '<=', timestamp).orderBy(orderByField, "desc").get().then((collection) => {
      commit('UPDATE_LOADING_MESSAGES', { roomId, value: false })
      commit('RESET_MESSAGES_FROM_CHAT', roomId);
      collection.docs.forEach((doc) => {
        const tmpMessage = doc.data();
        if (tmpMessage.text !== '') {
          if (('isReaded' in tmpMessage) && !tmpMessage.isReaded && tmpMessage.from !== user.uid) {
            commit('SUM_UNREAD_MESSAGE_TO_CHAT', roomId);
          }
          const message = parseMessageFromFirebase({...doc.data(), id : doc.id })

          // This only apply to chats from the agent console, for chat engine v1
          if (message.user.id === 0) {
            message.user.name = chat.name
          }

          const tmplastMessage = (chat.messages[chat.messages.length - 1]) ? chat.messages[chat.messages.length - 1] : message
          commit('SET_LAST_MESSAGE', { message: getLastMessage(tmplastMessage), roomId })
          commit('ADD_PREVIUS_MESSAGE_TO_CHAT', { message, roomId })
          commit('ADD_UNPARSED_MESSAGE_TO_CHAT', { roomId: roomId, unparsedMessage: {...doc.data(), id : doc.id} })
        }
      })
    })
  },
  async fetchAndListenAllMessagesFromChat({ rootGetters, commit, dispatch}, { roomId }) {
    const firebase = rootGetters.getFirebase;
    await dispatch("fetchLastMessageFromChatroom", { roomId });
    const chat = state.chats.find(chat => chat.roomId === roomId);
    const unsubscribe = firebase.firestore().collection(chat.path).doc(roomId).collection('messages').orderBy('createdAt', 'asc').onSnapshot((snapshot) => {
      commit('UPDATE_LOADING_MESSAGES', { roomId, value: false })
      for (const change of snapshot.docChanges()) {

        if (change.type === "added") {
          const message = parseMessageFromFirebase({...change.doc.data(), id : change.doc.id });
          //const lastMessage = chat.messages[chat.messages.length - 1];

          commit('SET_LAST_MESSAGE', { message, roomId })
          commit('ADD_MESSAGE_TO_CHAT', { message, roomId }); 
        }
      }
    })
    commit('UPDATE_UNSUBSCRIBE', { unsubscribe: unsubscribe, roomId: chat.roomId });
    return unsubscribe;
  }
  
}
function getLastMessage(tmpMessage) {
  const message = { ...tmpMessage }

  if (/<br>/.test(message.text)) {
    message.text = message.text.split("<br>").pop()
  }

  return message
}




export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};